import React, { useContext, useEffect } from 'react';
import { BodyText, HeadingText } from '@paypalcorp/pp-react-text';
import { CustomContainer, CustomRow } from '@MerchantConfigurator/components/common';
import {
  DefaultLocale,
  ErrorContents,
  errorImageAlt,
  errorImageUrl,
  Events,
  LifeCycleProducts,
  Sizes
} from '@MerchantConfigurator/constants';
import { ApplicationContext } from '@MerchantConfigurator/context';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';

const ErrorView = ({
  description,
  eventName = Events.errorStateViewed,
  locale = DefaultLocale
}) => {
  const headerMessage = ErrorContents[locale].header;
  const subheaderMessage = ErrorContents[locale].generic;
  const descriptionMessage = description || ErrorContents[locale].tryAgainLater;

  return (
    <CustomContainer>
      <CustomRow margin={`0 0 ${Sizes.xl} 0`}>
        <HeadingText size="lg">{headerMessage}</HeadingText>
      </CustomRow>
      <CustomContainer
        css={{
          textAlign: 'center',
          margingTop: Sizes['4xl'],
          padding: Sizes['xl']
        }}
      >
        <img style={{ width: '122px' }} src={errorImageUrl} alt={errorImageAlt} />
        <HeadingText size="sm" theme="v2" css={{ marginBottom: Sizes.lg }}>
          {subheaderMessage}
        </HeadingText>
        <BodyText
          theme="v2"
          css={{
            margin: 'auto',
            textAlign: 'center',
            width: '872px',
            '@media (max-width: 752px)': {
              width: '100%'
            }
          }}
        >
          {parse(descriptionMessage)}
        </BodyText>
      </CustomContainer>
    </CustomContainer>
  );
};

export default ErrorView;

ErrorView.propTypes = {
  description: PropTypes.string,
  eventName: PropTypes.string,
  locale: PropTypes.string
};
